module.exports = __webpack_public_path__ + "static/media/benefitsScoutsIcon01.a3ea56de.svg";